export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.galleryCategories = payload;

  return newState;
};
